export enum DoorWorkingModes {
  DoorReleased = 'DoorReleased',
  CardVerification = 'CardVerification',
  FirstReaderDisabled = 'FirstReaderDisabled',
  SecondReaderDisabled = 'SecondReaderDisabled',
  AllReadersDisabled = 'AllReadersDisabled',
}
